import type { ReactNode } from "react";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "@stubhub/broadway-web";
interface EmailOptInModalProps {
  readonly title: string;
  readonly isOpen: boolean;
  readonly onModalClose: () => void;
  readonly children?: ReactNode | undefined;
}

export const EmailOptInModal = (props: EmailOptInModalProps) => {
  const { title, isOpen, onModalClose, children } = props;
  // Modal renders as a bottom sheet below the "tablet" breakpoint; the legacy bottom sheet
  // allowed background interaction while the legacy modal dimmed it.
  const hasScrim = useMediaQuery(Breakpoint.Tablet);

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onModalClose();
        }
      }}
      dismissible
      hasScrim={hasScrim}
    >
      <ModalHeader>
        <ModalTitle>{title}</ModalTitle>
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
    </Modal>
  );
};
